import { render } from "./OverallScore.vue?vue&type=template&id=51e62406"
import script from "./OverallScore.vue?vue&type=script&lang=js"
export * from "./OverallScore.vue?vue&type=script&lang=js"

import "./OverallScore.vue?vue&type=style&index=0&id=51e62406&lang=scss"

import exportComponent from "C:\\Devprojects\\cedaci-compass\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__